import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformGRCPage from '@src/pages/Platform/GRC';

export const Route = createLazyFileRoute('/platform/grc')({
  component: PlatformGRCPageWithLayout,
});

function PlatformGRCPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformGRCPage />
    </DefaultLayout>
  );
}
